import {useEffect} from "react";
import ReactGA from "react-ga4";

export const useAnalytics = (pageName: string) => {
    useEffect(() => {
        ReactGA.send({ hitType: "pageview", title: pageName });
    }, []);
}